/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 会社
 * @export
 * @interface Company
 */
export interface Company {
    /**
     * 会社ID
     * @type {number}
     * @memberof Company
     */
    id: number;
    /**
     * 名称
     * @type {string}
     * @memberof Company
     */
    name: string;
    /**
     * かな名称
     * @type {string}
     * @memberof Company
     */
    kanaName?: string;
    /**
     * 短縮名
     * @type {string}
     * @memberof Company
     */
    shortName: string;
}

export function CompanyFromJSON(json: any): Company {
    return CompanyFromJSONTyped(json, false);
}

export function CompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Company {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'kanaName': !exists(json, 'kana_name') ? undefined : json['kana_name'],
        'shortName': json['shortName'],
    };
}

export function CompanyToJSON(value?: Company | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'kana_name': value.kanaName,
        'shortName': value.shortName,
    };
}


